import { LEGAL_BASIS_OF_STAY } from '@interfaces';

export const legalBasisOfStayList = {
  tempPremit: [
    {
      labelKey: 'TEMPORARY_RESIDENCE_PERMIT',
      value: LEGAL_BASIS_OF_STAY.TEMP_PERMIT,
    },
    {
      labelKey: 'VISA_FREE_REGIME',
      value: LEGAL_BASIS_OF_STAY.VISA_FREE,
    },
    {
      labelKey: 'VISA',
      value: LEGAL_BASIS_OF_STAY.VISA,
    },
    {
      labelKey: 'DOCUMENT_ENTITLING_ENTRY_AND_STAY_ISSUED_BY_ANOTHER_SCHENGEN_STATE',
      value: LEGAL_BASIS_OF_STAY.SCHENGEN_COUNTRY_ISSUED_DOC,
    },
    {
      labelKey: 'OTHER_BASIS',
      value: LEGAL_BASIS_OF_STAY.OTHER,
    },
  ],
  permStay: [
    {
      labelKey: 'VISA_FREE_REGIME',
      value: LEGAL_BASIS_OF_STAY.VISA_FREE,
    },
    {
      labelKey: 'VISA',
      value: LEGAL_BASIS_OF_STAY.VISA,
    },
    {
      labelKey: 'TEMPORARY_RESIDENCE_PERMIT',
      value: LEGAL_BASIS_OF_STAY.TEMP_PERMIT,
    },
    {
      labelKey: 'REFUGEE_STATUS',
      value: LEGAL_BASIS_OF_STAY.REFUGEE,
    },
    {
      labelKey: 'TOLERATED_STATUS',
      value: LEGAL_BASIS_OF_STAY.TOLERATED_STAY,
    },
    {
      labelKey: 'ASYLUM_STATUS',
      value: LEGAL_BASIS_OF_STAY.ASYLUM,
    },
    {
      labelKey: 'DOCUMENT_ENTITLING_ENTRY_AND_STAY_ISSUED_BY_ANOTHER_SCHENGEN_STATE',
      value: LEGAL_BASIS_OF_STAY.SCHENGEN_COUNTRY_ISSUED_DOC,
    },
  ],
  longResi: [
    {
      labelKey: 'VISA_FREE_REGIME',
      value: LEGAL_BASIS_OF_STAY.VISA_FREE,
    },
    {
      labelKey: 'VISA',
      value: LEGAL_BASIS_OF_STAY.VISA,
    },
    {
      labelKey: 'TEMPORARY_RESIDENCE_PERMIT',
      value: LEGAL_BASIS_OF_STAY.TEMP_PERMIT,
    },
    {
      labelKey: 'PERMANENT_RESIDENCE_PERMIT',
      value: LEGAL_BASIS_OF_STAY.PERM_STAY,
    },
    {
      labelKey: 'REFUGEE_STATUS',
      value: LEGAL_BASIS_OF_STAY.REFUGEE,
    },
    {
      labelKey: 'SUPPLEMENTARY_PROTECTION',
      value: LEGAL_BASIS_OF_STAY.SUBSIDIARY_PROTECTION,
    },
    {
      labelKey: 'DOCUMENT_ENTITLING_ENTRY_AND_STAY_ISSUED_BY_ANOTHER_SCHENGEN_STATE',
      value: LEGAL_BASIS_OF_STAY.SCHENGEN_COUNTRY_ISSUED_DOC,
    },
  ],
};

export const legalBasisOfWork = [
  'DELEGOWANIE',
  'INNA',
  'KONTRAKT MENEDŻERSKI',
  'MIANOWANIE',
  'POWOŁANIE',
  'SPÓŁDZIELCZA UMOWA O PRACĘ',
  'UMOWA AGENCYJNA',
  'UMOWA O DZIEŁO',
  'UMOWA O POMOCY PRZY ZBIORACH',
  'UMOWA O PRACĘ',
  'UMOWA O PRACĘ NA CZAS NIEOKREŚLONY',
  'UMOWA O PRACĘ NA CZAS OKREŚLONY',
  'UMOWA O PRACĘ NA OKRES PRÓBNY',
  'UMOWA O PRACĘ W ZASTĘPSTWIE',
  'UMOWA O ŚWIADCZENIE USŁUG',
  'UMOWA ZLECENIE',
];
